import { apiObjUrl } from "src/common/apiUrl";
import { rest } from "src/common/rest";
import { zAttrLabelsAttributes } from "src/common/attributes/makeAttrLabel/types/ZAttrLabelsData";
import { zEntity } from "src/types/ZEntity";
import { z } from "zod";
import { ZUid } from "src/types/zUid";

export const zEntitySearchData = z.object({
  totalElements: z.number(),
  content: zEntity.array(),
  attributesLabels: zAttrLabelsAttributes,
});
export type ZEntitySearchData = z.infer<typeof zEntitySearchData>;
/**
 * Нежелательно использовать данный метод, но есть случаи, когда это необходимо.
 * Все такие случаи обговариваются с постановщиками
 */
export const searchEntitiesAll = async (objectId: ZUid | null | undefined) =>
  rest
    .post(
      apiObjUrl("/entities/search"),
      {
        objectId,
      },
      { params: { withLabels: true } },
    )
    .then((resp) => zEntitySearchData.parse(resp.data));
